/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsemptybody2Inputs */

const en_earningsemptybody2 = /** @type {(inputs: Earningsemptybody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add tickets to an event, free or paid. You'll see here what has sold, what you keep after the ticket fee and when it is paid out.`)
};

const de_earningsemptybody2 = /** @type {(inputs: Earningsemptybody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege bei einem Event Tickets an, kostenlos oder bezahlt. Hier siehst du dann, was verkauft ist, was dir nach der Ticketgebühr bleibt und wann ausgezahlt wird.`)
};

/**
* | output |
* | --- |
* | "Add tickets to an event, free or paid. You'll see here what has sold, what you keep after the ticket fee and when it is paid out." |
*
* @param {Earningsemptybody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsemptybody2 = /** @type {((inputs?: Earningsemptybody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsemptybody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsemptybody2(inputs)
	return de_earningsemptybody2(inputs)
});
export { earningsemptybody2 as "earningsEmptyBody" }